import react from '../../assets/icons/react.svg'
const languages = [
    {
        icon: react,
        name: 'JavaScript',
        level: '60'
    },
    {
        icon: react,
        name: 'React',
        level: '45'
    },
    {
        icon: react,
        name: 'HTML',
        level: '60'
    },
        {
        icon: react,
        name: 'CSS',
        level: '70'
    }
]
const tools = [
    {
        icon: react,
        name: 'Robot Framework - Software Testing',
        level: '85'
    },
        {
        icon: react,
        name: 'Node js',
        level: '65'
    },
    {
        icon: react,
        name: 'Hackerrank & Leetcode',
        level: '65'
    }
]
export { tools, languages}